import React from "react";

const DeleteConfirmModal = ({ onConfirm, onClose, setIsModalOpen }) => {
  return (
    <div className="container fixed inset-0 flex items-center justify-center bg-whiteBg/80 z-50">
      <div className="flex flex-col top-[322px] left-[475px] w-[358px] h-[268px] rounded-lg p-4 gap-4 bg-whiteBg shadow-cardShadow hover:shadow-hoverShadow divide-y-2 divide-lineGray">
        <div className="w-[326px] h-[98px] ">
          <img
            src="/ünlem.svg"
            alt="Warning Icon"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="w-[326px] h-[50px] border-none gap-4 flex items-center justify-center">
          <h2 className="text-sm text-grayy font-medium text-center">
            Bu pozisyonu kaldırmak istediğinize emin misiniz?
          </h2>
        </div>

        <div className="flex items-center justify-center w-[326px] h-[40px] gap-4 pt-8">
          <button
            onClick={onConfirm}
            className="text-center text-sm btn-green text-dark w-full h-[40px] rounded-lg p-[12px]  "
          >
            Evet
          </button>
          <button
            onClick={() => {
              onClose();
              setIsModalOpen(false);
            }}
            className="text-center text-sm btn-dark text-white w-full h-[40px] rounded-lg p-[12px] "
          >
            Hayır
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
